export const ABOUT_EYEBROW = "ABOUT_EYEBROW";
export const ABOUT_TITLE = "ABOUT_TITLE";
export const ABOUT_TITLE_EMPHASIS = "ABOUT_TITLE_EMPHASIS";
export const ABOUT_SUBTITLE = "ABOUT_SUBTITLE";
export const ABOUT_STORY_LABEL = "ABOUT_STORY_LABEL";
export const ABOUT_STORY_HEADING = "ABOUT_STORY_HEADING";
export const ABOUT_STORY_PARA_1 = "ABOUT_STORY_PARA_1";
export const ABOUT_STORY_PARA_2 = "ABOUT_STORY_PARA_2";
export const ABOUT_STORY_PARA_3 = "ABOUT_STORY_PARA_3";
export const ABOUT_STATS_LABEL = "ABOUT_STATS_LABEL";
export const ABOUT_STATS_HEADING = "ABOUT_STATS_HEADING";
export const ABOUT_FOUNDERS_LABEL = "ABOUT_FOUNDERS_LABEL";
export const ABOUT_FOUNDERS_HEADING = "ABOUT_FOUNDERS_HEADING";
export const ABOUT_CTA_HEADING = "ABOUT_CTA_HEADING";
